function changeVideoSource(x, vid, smallVideoUrl, largeVideoUrl) {
    if (x.matches) { // If media query matches
        if(smallVideoUrl != ''){
            vid.src = smallVideoUrl;
        } else {
            vid.src = largeVideoUrl;
        }
        vid.load();
    } else {
        vid.src = largeVideoUrl;
        vid.load();
    }
}
